import Availabilities from 'reservations/availabilities/components/Availabilities';
import { MaxPartySizeText } from 'reservations/availabilities/components/MaxPartySizeText';
import { useIsBeyondMaxPartySize } from 'reservations/availabilities/hooks/useIsBeyondMaxPartySize';

interface Props {
  numberOfGuests?: number;
}

function AvailabilitiesContainer({ numberOfGuests = 0 }: Props) {
  const isBeyondMaxPartySize = useIsBeyondMaxPartySize();
  return isBeyondMaxPartySize ? (
    <MaxPartySizeText />
  ) : (
    <Availabilities numberOfGuests={numberOfGuests} />
  );
}

export default AvailabilitiesContainer;
